import { render } from "./DocumentExtractionDialog.vue?vue&type=template&id=ac9dbb78"
import script from "./DocumentExtractionDialog.vue?vue&type=script&lang=js"
export * from "./DocumentExtractionDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__